import { Controller } from "@hotwired/stimulus"

export default class HeroVideoPickerController extends Controller {
  static targets = [
    "modal",
    "grid",
    "preview",
    "previewVideo",
    "placeholder",
    "videoUrlInput",
    "videoPosterInput",
    "urlInput",
    "clearBtn"
  ]

  static values = {
    currentCategory: { type: String, default: "all" }
  }

  connect() {
    this._boundHandleKeydown = this.handleKeydown.bind(this)

    // 기존 videoUrlInput 값이 있으면 미리보기 표시, 없으면 명시적으로 숨김
    if (this.hasVideoUrlInputTarget && this.videoUrlInputTarget.value) {
      this._showPreview(this.videoUrlInputTarget.value, this.hasVideoPosterInputTarget ? this.videoPosterInputTarget.value : "")
    } else {
      this._hidePreview()
    }
  }

  disconnect() {
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  open(event) {
    event.preventDefault()
    this.modalTarget.style.display = "flex"
    document.body.style.overflow = "hidden"
    document.addEventListener("keydown", this._boundHandleKeydown)
  }

  close() {
    this.modalTarget.style.display = "none"
    document.body.style.overflow = ""
    document.removeEventListener("keydown", this._boundHandleKeydown)
  }

  closeOnBackdrop(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  selectCategory(event) {
    const category = event.currentTarget.dataset.category
    this.currentCategoryValue = category

    // 영상 아이템 필터링
    const items = this.gridTarget.querySelectorAll(".video-picker__item")
    items.forEach(item => {
      if (category === "all" || item.dataset.category === category) {
        item.style.display = ""
      } else {
        item.style.display = "none"
      }
    })

    // 탭 active 상태 업데이트
    const tabs = this.element.querySelectorAll("[data-action*='selectCategory']")
    tabs.forEach(tab => {
      tab.classList.remove("video-picker__tab--active")
    })
    event.currentTarget.classList.add("video-picker__tab--active")
  }

  selectVideo(event) {
    const url = event.currentTarget.dataset.url
    const poster = event.currentTarget.dataset.poster || ""

    this.videoUrlInputTarget.value = url
    if (this.hasVideoPosterInputTarget) this.videoPosterInputTarget.value = poster
    this._showPreview(url, poster)

    // 그리드 내 선택 표시 초기화 후 클릭된 항목에 선택 표시 추가
    const items = this.gridTarget.querySelectorAll(".video-picker__item")
    items.forEach(item => {
      item.classList.remove("video-picker__item--selected")
    })
    event.currentTarget.classList.add("video-picker__item--selected")

    // 200ms 후 close (선택 확인용 딜레이)
    setTimeout(() => {
      this.close()
    }, 200)
  }

  applyUrl() {
    const url = this.urlInputTarget.value.trim()
    if (!url) return

    this.videoUrlInputTarget.value = url
    this._showPreview(url, "")
    this.close()
  }

  clearSelection() {
    this.videoUrlInputTarget.value = ""
    if (this.hasVideoPosterInputTarget) this.videoPosterInputTarget.value = ""
    this._hidePreview()

    // 그리드 내 선택 표시 모두 제거
    if (this.hasGridTarget) {
      const items = this.gridTarget.querySelectorAll(".video-picker__item")
      items.forEach(item => {
        item.classList.remove("video-picker__item--selected")
      })
    }
  }

  // --- private helpers ---

  _showPreview(url, poster) {
    this.previewVideoTarget.poster = poster || ""
    this.previewVideoTarget.src = url
    this.previewVideoTarget.load()
    this.previewVideoTarget.style.display = ""
    this.previewTarget.style.display = "inline-block"
    this.placeholderTarget.style.display = "none"
    this.clearBtnTarget.style.display = "inline-flex"
  }

  _hidePreview() {
    this.previewVideoTarget.poster = ""
    this.previewVideoTarget.src = ""
    this.previewVideoTarget.style.display = ""
    this.previewTarget.style.display = "none"
    this.placeholderTarget.style.display = "block"
    this.clearBtnTarget.style.display = "none"
  }
}
